(function () {
  'use strict';
  var host = document.querySelector('[data-idv-gallery-experiment]');
  if (!host || host.dataset.bound) return;
  host.dataset.bound = 'true';
  var config = JSON.parse(host.querySelector('[type="application/json"]').textContent);
  var state = window.idvGalleryExperiment;
  if (!state || state.failed) return;
  var section = host.closest('.shopify-section');
  var nativeGallery = host.parentElement.querySelector('.media-sliders');
  var items = config.items, index = 0, ready = false, exposureSent = false, viewed = false;
  var track, thumbs, slides, dialog, opener, lastColour, scrollFrame;
  var measurement = 'G-8HCMWVSWJM';

  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function send(action, details) {
    if (state.preview || state.failed || !allowed() || !ready) return false;
    window.dataLayer = window.dataLayer || [];
    var tag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!state.tagReady) {
      tag('config', measurement, {send_page_view: false});
      state.tagReady = true;
    }
    tag('event', 'idv_gallery_' + action + '_' + state.arm, Object.assign({
      send_to: measurement, experiment_id: config.experimentId,
      experiment_variant: state.arm, product_id: String(config.productId),
      transport_type: 'beacon'
    }, details || {}));
    return true;
  }
  function expose() {
    if (viewed && !exposureSent) exposureSent = send('view');
  }
  function saveAssignment() {
    if (state.preview || state.failed || !allowed()) return;
    try { localStorage.setItem(state.key, JSON.stringify({arm:state.arm, expires:state.expires})); } catch (_) {}
  }
  document.addEventListener('visitorConsentCollected', function () {
    if (allowed()) { saveAssignment(); expose(); }
    else { try { localStorage.removeItem(state.key); } catch (_) {} }
  });
  if (window.Shopify && !Shopify.customerPrivacy && Shopify.loadFeatures) {
    Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error) {
      if (!error) { saveAssignment(); expose(); }
    });
  }
  function observeExposure() {
    var target = state.arm === 'model' ? host : nativeGallery;
    if (!target) return;
    if (!window.IntersectionObserver) { viewed = true; expose(); return; }
    var observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        viewed = true; expose(); observer.disconnect();
      }
    }, {threshold:0.15});
    observer.observe(target);
  }
  function fallback(reason) {
    state.failed = true;
    clearTimeout(state.timer);
    document.documentElement.removeAttribute('data-idv-gallery-arm');
    host.hidden = true;
    host.dataset.status = 'fallback';
    host.dataset.failure = reason;
    if (nativeGallery) nativeGallery.removeAttribute('inert');
    if (dialog && dialog.open) dialog.close();
  }
  window.addEventListener('error', function (event) {
    if (event.target && event.target.matches && event.target.matches('[data-idv-gallery-image]')) fallback('image');
  }, true);

  function cdn(url, width) {
    var value = new URL(url, location.href);
    value.searchParams.set('width', String(width));
    return value.href;
  }
  function loadImage(image, item, eager) {
    if (image.hasAttribute('src')) return;
    image.alt = item.alt;
    image.width = item.width; image.height = item.height;
    image.decoding = 'async';
    image.setAttribute('data-idv-gallery-image', '');
    image.loading = eager ? 'eager' : 'lazy';
    image.sizes = '(min-width: 1000px) 58vw, 100vw';
    image.srcset = [400,640,900,1122].map(function (width) { return cdn(item.url,width)+' '+width+'w'; }).join(', ');
    if (eager) image.fetchPriority = 'high';
    image.src = cdn(item.url,1122);
  }
  function warm(i) {
    [i-1,i,i+1].forEach(function (n) {
      if (n>=0 && n<items.length) loadImage(slides[n].querySelector('img'),items[n],n===i);
    });
  }
  function update(i, action) {
    index = Math.max(0, Math.min(items.length-1,i));
    host.dataset.colour = items[index].colour;
    host.dataset.view = items[index].view;
    host.dataset.index = String(index);
    warm(index);
    thumbs.forEach(function (button,n) { button.setAttribute('aria-current',n===index?'true':'false'); });
    slides.forEach(function (slide,n) { slide.setAttribute('aria-hidden',n===index?'false':'true'); slide.querySelector('button').tabIndex=n===index?0:-1; });
    host.querySelector('[data-gallery-count]').textContent = (index+1)+' / '+items.length;
    host.querySelector('[data-gallery-caption]').textContent = items[index].colour+' / '+items[index].label;
    host.querySelector('[data-gallery-prev]').disabled = index===0;
    host.querySelector('[data-gallery-next]').disabled = index===items.length-1;
    var thumbTrack = host.querySelector('[data-gallery-thumbs]');
    thumbTrack.scrollLeft = Math.max(0,thumbs[index].offsetLeft-thumbTrack.offsetLeft-thumbTrack.clientWidth/2+thumbs[index].clientWidth/2);
    if (action && ready) send('interact',{gallery_action:action,colour:items[index].colour,image_view:items[index].view});
  }
  function go(i, action) {
    update(i,action);
    track.scrollTo({left:index*track.clientWidth,behavior:'instant'});
  }
  function selectColour(colour) {
    var selected = items.findIndex(function (item) { return item.colour===colour && item.view==='front'; });
    if (selected<0) return;
    lastColour=colour;
    if (track) go(selected,ready?'colour':null);
    else index=selected;
  }
  document.addEventListener('idv:stonewash-gallery-colour',function(event) {
    if (event.detail && event.detail.productId===config.productId && state.arm==='model' && !state.failed) selectColour(event.detail.colour);
  });
  document.addEventListener('idv:stonewash-cart-added',function(event) {
    if (event.detail && event.detail.productId===config.productId) {
      expose();
      send('cart',{quantity:event.detail.quantity,currency:event.detail.currency,value:event.detail.value});
    }
  });

  if (state.arm === 'control') {
    ready=true; state.ready=true; clearTimeout(state.timer); host.hidden=true;
    saveAssignment(); observeExposure();
    if (nativeGallery) nativeGallery.addEventListener('click',function(event) {
      if (event.target.closest('button,a')) send('interact',{gallery_action:'native_gallery'});
    });
    return;
  }

  try {
    host.appendChild(host.querySelector('template').content.cloneNode(true));
    host.hidden=false;
    track=host.querySelector('[data-gallery-track]');
    thumbs=Array.from(host.querySelectorAll('[data-gallery-thumb]'));
    slides=Array.from(host.querySelectorAll('[data-gallery-slide]'));
    dialog=host.querySelector('dialog');
    assertCount();
    var current = section.querySelector('.ivpb__current-color');
    selectColour(lastColour || (current && current.textContent.trim()) || config.initialColour);
    go(index);
    track.addEventListener('scroll',function() {
      cancelAnimationFrame(scrollFrame);
      scrollFrame=requestAnimationFrame(function() {
        var next=Math.round(track.scrollLeft/track.clientWidth);
        if(next!==index) update(next,'swipe');
      });
    }, {passive:true});
    track.addEventListener('keydown',function(event) {
      if(event.key==='ArrowRight'||event.key==='ArrowLeft') { event.preventDefault();go(index+(event.key==='ArrowRight'?1:-1),'keyboard'); }
      if(event.key==='Home'||event.key==='End') { event.preventDefault();go(event.key==='Home'?0:items.length-1,'keyboard'); }
    });
    host.querySelector('[data-gallery-prev]').addEventListener('click',function(){go(index-1,'previous');});
    host.querySelector('[data-gallery-next]').addEventListener('click',function(){go(index+1,'next');});
    thumbs.forEach(function(button,n) { button.addEventListener('click',function(){go(n,'thumbnail');}); });
    var resize = new ResizeObserver(function(){track.scrollTo({left:index*track.clientWidth,behavior:'instant'});});
    resize.observe(track);
    slides.forEach(function(slide,n) {
      slide.querySelector('button').addEventListener('click',function(event) {
        var image=dialog.querySelector('img');
        image.src=cdn(items[n].url,items[n].width);image.alt=items[n].alt;
        opener=event.currentTarget;dialog.showModal();
        dialog.querySelector('button').focus();send('interact',{gallery_action:'zoom',colour:items[n].colour,image_view:items[n].view});
      });
    });
    dialog.querySelector('button').addEventListener('click',function(){dialog.close();});
    dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
    dialog.addEventListener('close',function(){if(opener && opener.isConnected)opener.focus({preventScroll:true});});
    var initialImage=slides[index].querySelector('img');
    function activate() {
      if(state.failed)return;
      ready=true;state.ready=true;clearTimeout(state.timer);
      host.dataset.status='ready';
      nativeGallery.setAttribute('inert','');
      saveAssignment();observeExposure();
    }
    if(initialImage.complete && initialImage.naturalWidth)activate();
    else initialImage.addEventListener('load',activate,{once:true});
  } catch(error) { fallback('initialization'); }
  function assertCount() {
    if(items.length!==24 || slides.length!==24 || thumbs.length!==24) throw Error('Incomplete gallery');
  }
})();
